import { ZipFileComponent } from './zip-file.component';
export var zipFileRoutes = [
    {
        path: 'zipFile',
        component: ZipFileComponent,
        data: {
            'expectedRoles': ['Accountant Admin']
        },
    },
];
var ZipFileRoutingModule = (function () {
    function ZipFileRoutingModule() {
    }
    return ZipFileRoutingModule;
}());
export { ZipFileRoutingModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/zip-file/zip-file-routing.module.ts.pre-build-optimizer.js